import React from 'react';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

const PasswordStrengthIndicator = ({ password, validation }) => {
  if (!password) return null;

  const getStrengthColor = (score) => {
    switch(score) {
      case 0: return 'bg-red-500';
      case 1: return 'bg-red-400';
      case 2: return 'bg-yellow-500';
      case 3: return 'bg-yellow-400';
      case 4: return 'bg-green-400';
      case 5: return 'bg-green-500';
      default: return 'bg-gray-300';
    }
  };

  const getStrengthText = (strength) => {
    switch(strength) {
      case 'Très faible': return { text: strength, color: 'text-red-600' };
      case 'Faible': return { text: strength, color: 'text-red-500' };
      case 'Moyen': return { text: strength, color: 'text-yellow-600' };
      case 'Bon': return { text: strength, color: 'text-yellow-500' };
      case 'Fort': return { text: strength, color: 'text-green-500' };
      case 'Très fort': return { text: strength, color: 'text-green-600' };
      default: return { text: 'Inconnu', color: 'text-gray-500' };
    }
  };

  const strengthInfo = getStrengthText(validation.strength);

  return (
    <div className="mt-2 space-y-2">
      {/* Progress bar */}
      <div className="flex space-x-1">
        {[1, 2, 3, 4, 5].map((level) => (
          <div
            key={level}
            className={`h-2 flex-1 rounded ${
              level <= validation.score 
                ? getStrengthColor(validation.score)
                : 'bg-gray-200'
            } transition-colors duration-200`}
          />
        ))}
      </div>

      {/* Strength text */}
      <div className="flex items-center justify-between">
        <span className={`text-sm font-medium ${strengthInfo.color}`}>
          Force: {strengthInfo.text}
        </span>
        {validation.is_valid ? (
          <CheckCircle className="w-4 h-4 text-green-500" />
        ) : (
          <XCircle className="w-4 h-4 text-red-500" />
        )}
      </div>

      {/* Requirements list */}
      {validation.issues.length > 0 && (
        <div className="text-xs space-y-1">
          <div className="flex items-center gap-1 text-amber-600">
            <AlertCircle className="w-3 h-3" />
            <span className="font-medium">Requis:</span>
          </div>
          <ul className="ml-4 space-y-0.5">
            {validation.issues.map((issue, index) => (
              <li key={index} className="text-gray-600 flex items-center gap-1">
                <span className="w-1 h-1 bg-gray-400 rounded-full" />
                {issue}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PasswordStrengthIndicator;